import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import AuthContext from "../contexts/auth";

export default function FloatingPremiumButton() {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const isPremium = !!(
    user?.subscriptionExpiresAt &&
    new Date(user.subscriptionExpiresAt) > new Date()
  );

  // Só aparece na home, pra quem ainda não é assinante — removido de
  // "Meus Cadernos" a pedido do cliente (2026-07-28).
  if (isPremium || location.pathname !== "/") return null;

  return (
    <Link to="/planoanual" className="floating-premium-btn">
      <FaCrown className="floating-premium-crown" />
      <span>
        Plano Anual: tenha acesso livre
        <br />a todos os Cadernos durante 1 ano
      </span>
    </Link>
  );
}
